import { Avatar as MuiAvatar, SxProps } from '@mui/material';

// TODO: Move to componentLibrary (Design System) with proper story and documentation

const SYSTEM_AVATARS = [
    '/static/images/avatars/Avatar_B_01.png',
    '/static/images/avatars/Avatar_B_02.png',
    '/static/images/avatars/Avatar_B_03.png',
    '/static/images/avatars/Avatar_B_04.png',
    '/static/images/avatars/Avatar_B_05.png',
    '/static/images/avatars/Avatar_B_06.png',
    '/static/images/avatars/Avatar_B_07.png',
    '/static/images/avatars/Avatar_B_08.png',
    '/static/images/avatars/Avatar_B_09.png',
    '/static/images/avatars/Avatar_B_10.png',
    '/static/images/avatars/Avatar_B_11.png',
    '/static/images/avatars/Avatar_B_12.png',
    '/static/images/avatars/Avatar_B_13.png',
    '/static/images/avatars/Avatar_B_14.png',
    '/static/images/avatars/Avatar_B_15.png',
    '/static/images/avatars/Avatar_B_16.png',
    '/static/images/avatars/Avatar_B_17.png',
    '/static/images/avatars/Avatar_B_18.png',
    '/static/images/avatars/Avatar_B_19.png',
    '/static/images/avatars/Avatar_B_20.png',
];

const hashString = (str: string) => {
    let hash = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < str.length; i++) {
        // eslint-disable-next-line no-bitwise
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        // eslint-disable-next-line no-bitwise
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
};

interface IAvatarProps {
    src?: string;
    firstName?: string;
    sx?: SxProps;
    avatarUrl?: string;
}

// Defer image network + decode work until the avatar is near the viewport.
// Without this, mobile devices can OOM when many rows render at once
// (e.g. the full leaderboard modal).
const LAZY_IMG_PROPS = { loading: 'lazy', decoding: 'async' } as const;
const SMALL_AVATAR_SX = { width: 25, height: 25 };

const getRandomAvatar = (name?: string) => {
    if (!name) {
        return SYSTEM_AVATARS[Math.floor(Math.random() * SYSTEM_AVATARS.length)];
    }

    const hash = hashString(name.toLowerCase());
    return SYSTEM_AVATARS[hash % SYSTEM_AVATARS.length];
};

const getSmallAvatarSx = (sx?: SxProps): SxProps => {
    if (!sx) {
        return SMALL_AVATAR_SX;
    }

    if (Array.isArray(sx)) {
        return [SMALL_AVATAR_SX, ...sx] as SxProps;
    }

    return [SMALL_AVATAR_SX, sx] as SxProps;
};

const Avatar = ({ src, firstName, sx, avatarUrl }: IAvatarProps) => {
    if (avatarUrl) {
        return (
            <MuiAvatar
                className="avatar"
                src={avatarUrl}
                sx={getSmallAvatarSx(sx)}
                slotProps={{ img: LAZY_IMG_PROPS }}
            />
        );
    }

    return (
        <MuiAvatar
            className="avatar"
            src={src || getRandomAvatar(firstName)}
            sx={sx}
            slotProps={{ img: LAZY_IMG_PROPS }}
        />
    );
};

export default Avatar;
